// extracted by mini-css-extract-plugin
export default {"avatar":"u56B9I","withBorder":"h0KJOB","memberInitials":"AAPsDi","avatarPlaceholder":"qAeeru","loggedOut":"cl1ps1"};